<template>
  <video
    ref="video"
    controls
    class="video-js vjs-default-skin vjs-big-play-centered"
    :poster="options.poster"
    style="width: 100%; height: 100%; padding-top: 0"
    controlslist="nodownload"
    webkit-playsinline="true"
    @contextmenu.prevent
  ></video>
</template>

<script>
export default {
  name: 'VideoPlayer',
  data: () => ({
    player: null,
    playFn: null,
    pauseFn: null,
    currentTime: 0,
    // 视频参数设置
    options: {
      playbackRates: [1.0, 1.25, 1.5, 2.0], // 播放速度
      autoplay: true, // 如果true,浏览器准备好时开始播放。
      muted: false, // 默认情况下将会消除任何音频。
      loop: false, // 导致视频一结束就重新开始。
      preload: 'auto', // auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      language: 'zh-CN',
      aspectRatio: '16:9', // 播放器的比例。用冒号分隔的两个数字（例如"16:9"或"4:3"）
      fluid: true, // 当true时，播放器将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      sources: [
        {
          type: '',
          src: '', // url地址
        },
      ],
      poster: '', // 你的封面地址
      //currentTime:0, //当前播放时间点
      //maxCurrentTime:0, //最大播放时间
      //duration:0,  //本视频的时长
      // width: document.documentElement.clientWidth,
      notSupportedMessage: '此视频暂无法播放，请稍后再试', // 无法播放媒体源时显示的默认信息。
      controlBar: {
        timeDivider: true,
        durationDisplay: true,
        remainingTimeDisplay: true,
        fullscreenToggle: true, // 全屏按钮
      },
      errorDisplay: false,
      posterImage: true,
      bigPlayButton: true,
      textTrackDisplay: false,
    },
  }),
  watch: {
    src() {
      // console.log('观测到src已发生变化：' + this.src);
      this.player.src(this.src);
      this.player.currentTime(this.currentTime); //断点续学
    },
  },
  computed: {
    src() {
      return this.options.sources[0].src;
    },
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    initVideo() {
      const vm = this;
      this.player = this.$video(this.$refs.video, this.options, function () {
        this.on('play', function () {
          // console.log('视频开始播放');
          if (typeof vm.playFn === 'function') {
            vm.playFn();
          }
        });
        this.on('pause', function () {
          // console.log('视频暂停播放');
          if (typeof vm.pauseFn === 'function') {
            vm.pauseFn();
          }
        });
        this.on('error', () => {
          // 因为网络加载失败时 重新尝试
          const err = this.error();
          // console.log(err);
        });
      });
    },
  },
};
</script>
